import { useWizardWithData } from '../../../../../../../../core/hooks/WizardWithData';
import { AodReportFactory, useAodFactory } from '../../custom/AodFactory';
import { defineMessage } from 'react-intl';
import { AodRuleStep_BasicInfo } from './basic-info/BasicInfoStep';
import { AodRuleStep_ReviewStep } from './review/ReviewStep';

export function createStepForField(field: keyof AodReportFactory['wizardForms']) {
  return function ReportConfigStep() {
    const { data } = useWizardWithData();
    const { wizardForms: formsComponents } = useAodFactory(data?.basic.reportType);

    const FormComponent = formsComponents[field];

    if (!FormComponent) {
      return null;
    }

    return <FormComponent />;
  };
}

export const aodRuleSteps = [
  {
    id: 'basic-info',
    labelMessage: defineMessage({
      id: 'audit.aod.rules.wizard.basicInfo',
      defaultMessage: 'Información Básica',
    }),
    Content: AodRuleStep_BasicInfo,
  },
  {
    id: 'report-config',
    labelMessage: defineMessage({
      id: 'audit.aod.rules.wizard.reportConfig',
      defaultMessage: 'Configuración del Reporte',
    }),
    Content: createStepForField('ReportConfig'),
  },
  {
    id: 'export-options',
    labelMessage: defineMessage({
      id: 'audit.aod.rules.wizard.exportOptions',
      defaultMessage: 'Export de evidencia',
    }),
    Content: createStepForField('ExportOptions'),
  },
  {
    id: 'export-conditions',
    labelMessage: defineMessage({
      id: 'audit.aod.rules.wizard.exportConditions',
      defaultMessage: 'Condiciones de Export',
    }),
    Content: createStepForField('ExportConditions'),
  },
  {
    id: 'review',
    labelMessage: defineMessage({
      id: 'audit.aod.rules.wizard.review',
      defaultMessage: 'Revisión',
    }),
    Content: AodRuleStep_ReviewStep,
  },
] as const;

export type AodRuleSteps = typeof aodRuleSteps;
